import { TSelectedSkuItem } from "@elixir/types";
import React from "react";
import {
  CreateServicePopupUi,
  ListOfServicesUi,
  PopoverContainerUi,
  ServicesLoadingStateUi,
} from "ui";
import useGetServicesMasterAutosuggest from "../../../../apis/axon/services/use-get-services-master-autosuggest";
import useDebounce from "../../../../hooks/use-debounce";

export type TListOfServicesPopupProps = {
  onClose: () => void;
  selectedServiceSkus: TSelectedSkuItem[];
  handleOnServiceClick: (serviceSku: TSelectedSkuItem) => void;
  onCreateNewService?: (serviceSku: TSelectedSkuItem) => void;
};

const ServicesPopup = ({
  selectedServiceSkus,
  onClose,
  handleOnServiceClick,
  onCreateNewService,
}: TListOfServicesPopupProps) => {
  const [serviceInput, setServiceInput] = React.useState<string>("");
  const debouncedServiceInput = useDebounce(serviceInput);

  const { data: ownerServicesAutosuggestData, isLoading } =
    useGetServicesMasterAutosuggest({
      query: debouncedServiceInput,
      pageSize: 100,
    });

  const skusToShow = ownerServicesAutosuggestData?.data || [];

  const [servicesCurrState, setServicesCurrState] = React.useState<
    "LIST" | "CREATE"
  >(() => (skusToShow.length > 0 ? "LIST" : "CREATE"));

  React.useEffect(() => {
    if (debouncedServiceInput === "" && skusToShow.length === 0) {
      setServicesCurrState("CREATE");
    } else {
      setServicesCurrState("LIST");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedServiceInput, isLoading]);

  const handleOnCreateServiceClick = () => {
    setServicesCurrState("CREATE");
  };

  const handleGoBackOnCreateService = () => {
    setServicesCurrState("LIST");
  };

  const handleCreateNewSubmit = (serviceSku: TSelectedSkuItem) => {
    // handleOnServiceClick(serviceSku);
    onCreateNewService?.(serviceSku);
    handleGoBackOnCreateService();
  };

  if (debouncedServiceInput === "" && isLoading) {
    return (
      <PopoverContainerUi className="dr-max-h-408 dr-min-h-408 dr-overflow-y-hidden dr-max-w-408 dr-w-408 dr-flex dr-flex-col">
        <ServicesLoadingStateUi />
      </PopoverContainerUi>
    );
  }

  return (
    <PopoverContainerUi className="dr-max-h-408 dr-min-h-408 dr-overflow-y-hidden dr-max-w-408 dr-w-408 dr-flex dr-flex-col">
      {servicesCurrState === "LIST" ? (
        <ListOfServicesUi
          serviceInput={serviceInput}
          onServiceInputChange={setServiceInput}
          skus={skusToShow}
          selectedServiceSkus={selectedServiceSkus}
          onClose={onClose}
          handleOnServiceClick={handleOnServiceClick}
          onCreateServiceClick={handleOnCreateServiceClick}
          isLoading={isLoading}
        />
      ) : (
        <CreateServicePopupUi
          onGoBack={handleGoBackOnCreateService}
          onSubmitClick={handleCreateNewSubmit}
        />
      )}
    </PopoverContainerUi>
  );
};

export default ServicesPopup;
